module.exports = __webpack_public_path__ + "static/media/science-teacher.95de12d0.jpg";